import { Button } from '@mui/material';
import { Fragment, useState } from 'react';
import ConfirmDialog from './Confirm';
import PasswordConfirmDialog from './PasswordConfirm';

interface Props {
  title: string;
  color?: string;
}

function ConfirmButton({ title, color }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const [isPasswordOpen, setIsPasswordOpen] = useState(false);

  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);
  const onSwitchToPasswordFind = () => setIsPasswordOpen(true);
  const onClosePassword = () => setIsPasswordOpen(false);

  return (
    <Fragment>
      <Button
        size="small"
        variant="text"
        onClick={onOpen}
        sx={theme => ({
          color: color || 'inherit',
          minWidth: 0,
          px: 0.5,
          backgroundColor: 'transparent',
          '&:hover': { backgroundColor: theme.palette.action.hover },
          '&:focusVisible': { backgroundColor: theme.palette.action.hover },
        })}
      >
        {title}
      </Button>

      <ConfirmDialog
        title={title}
        isOpen={isOpen}
        onClose={onClose}
        onSwitchToPasswordFind={onSwitchToPasswordFind}
      />

      <PasswordConfirmDialog
        title="비밀번호 찾기"
        isOpen={isPasswordOpen}
        onClose={onClosePassword}
      />
    </Fragment>
  );
}

export default ConfirmButton;
